export default (id = null) => ({
  id,
  loaded: false,
  loading: false,
  exists: true
});
